/** Resolve bundled fonts without coupling BlockSuite to the application shell. */
export function resolveLocalFontUrl(fileName: string): string {
  const runtime = globalThis as typeof globalThis & {
    environment?: { publicPath?: string };
  };
  // Workers do not bootstrap the application environment. Their emitted JS URL
  // still carries the installation prefix, including custom asset protocols.
  const currentUrl =
    typeof location === 'undefined' ? null : new URL(location.href);
  const jsIndex = currentUrl?.pathname.lastIndexOf('/js/') ?? -1;
  const workerBasePath =
    currentUrl && jsIndex >= 0
      ? currentUrl.pathname.slice(0, jsIndex + 1)
      : '/';
  const publicPath = runtime.environment?.publicPath || workerBasePath;
  const assetPath = `${publicPath.replace(/\/$/, '')}/fonts/${fileName}`;
  return !currentUrl ? assetPath : new URL(assetPath, currentUrl).toString();
}
